<template>
  <button
    @click="$emit('click')"
    class="btn-reset tw-flex tw-w-full tw-gap-2 tw-items-center tw-border tw-border-solid tw-rounded-lg tw-p-5 tw-font-medium"
    :class="{ 'tw-border-blue-300': selected, 'tw-border-gray-300': !selected }">
      <span class="tw-rounded-full tw-w-5 tw-h-5 tw-border tw-border-solid"
            :class="{'tw-border-[6px] tw-border-blue-500': selected, 'tw-border-gray-300': !selected}"
      />
    <span>{{title}}</span>
  </button>
</template>
<script>
export default {
  props: {
    selected: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>